import { HttpContext, HttpRequest } from '@angular/common/http';
import { ILoaderOptions } from '@partners/api';
import { IMockArgs } from '../../mock';
import { IHttpContext, IUrlModifiers } from '../model';
import { HTTP_CONTEXT } from '../tokens';

export class ContextBuilder {
  private readonly _defaultContext: IHttpContext = {
    loader: { toggle: true, options: [{ animation: 'default' }] },
    mock: { args: undefined },
    resolvers: { severities: [] },
    urlModifiers: {
      omitProcess: false
    }
  };

  private _context: IHttpContext;

  constructor() {
    this._context = { ...this._defaultContext };
    return this;
  }

  static getContext(request: HttpRequest<unknown>): IHttpContext {
    return request.context.get(HTTP_CONTEXT);
  }

  build(): HttpContext {
    const newContext = new HttpContext();
    newContext.set<IHttpContext>(HTTP_CONTEXT, this._context);
    return newContext;
  }

  append<T = Partial<IHttpContext>>(context: T): ContextBuilder {
    this._context = { ...this._context, ...context };
    return this;
  }

  /**
   * preset contexts
   **/
  disableLoader(): ContextBuilder {
    return this.append({ loader: { toggle: false } });
  }
  enableLoader(): ContextBuilder {
    return this.append({ loader: { toggle: true } });
  }
  addMockArgs(mockArgs: IMockArgs): ContextBuilder {
    return this.append({ mock: { args: { ...mockArgs } } });
  }

  addUrlModifiers(urlModifiers: IUrlModifiers): ContextBuilder {
    return this.append({ urlModifiers: { ...urlModifiers } });
  }

  withLoaderAnimation(options: ILoaderOptions[]) {
    options.forEach((option) => {
      if (!option.animation) {
        option.animation = 'default';
      }
    });
    return this.append({ loader: { options } });
  }
}
